import jQuery from 'jquery'

// We add event handler for #session-locale-choice form when
// it appears.
// We do this because we fetch footer html with this locale form from
// the Vue component LocalMapWithList.
jQuery(document).on('change', '#session-locale-choice select', null, (event) =>
  jQuery(event.target).closest('form').submit())
